<div class="suggested-points__interests_filter">  
  <ci-chip-set 
    overflow
    multiselect
    (change)="handleSelectedInterest($event)"
    >
    @for(interest of interestList(); track interest.id; let i = $index) {
      <ci-filter-chip-outline
        [chip]="interest"
        [value]="interest.id"
        [attr.data-value]="interest.id"
      >
        <span slot="label">{{ interest.label?.[translate?.currentLang] }}</span>
      </ci-filter-chip-outline>
    }
  </ci-chip-set>
</div>